import "./polyfills";

import App from "@/App.vue";
import LoadingApp from "@/LoadingApp.vue";
import router from "@/router";
import Vue, { VNode } from "vue";
import { ValidationService, TranslationService } from "@fkui/logic";
import { ETranslationProvider } from "@exp/vue";
import {
    TranslationPlugin,
    ValidationPlugin,
    TestPlugin,
    ErrorPlugin,
    FErrorHandlingApp,
    UNHANDLED_ERROR_EVENT,
    EventBus,
    ErrorData,
} from "@fkui/vue";
import { translateValidationMessages } from "@exp/vue";
import { clientLog } from "@exp/clientlog";
import { APP_SLUG, TEXT_URL } from "./constants";
import store from "./store";
import { AnmalanService } from "./services/AnmalanService";
import FkTeknisktfel from "./views/FkTeknisktFel.vue";

import "./main.scss";
import "fk-icons/dist/f";
import { validationMixin } from "./utils/mixins";

Vue.config.productionTip = false;

async function createLoadingApp(): Promise<void> {
    new Vue({
        render: (h): VNode => h(LoadingApp),
    }).$mount("#app");
}

async function loadTranslations(): Promise<void> {
    const translationProvider = new ETranslationProvider();
    const translateFunction = await translationProvider.createTranslateFunction(
        { language: "sv" },
    );

    try {
        await translationProvider.loadTranslations(TEXT_URL);
        await ValidationService.addValidationErrorMessages({
            maxLength: translateFunction("SBRV.RW.textfalt.fel.max"),
        });
    } catch (error) {
        // Ignore error silently..
    } finally {
        TranslationService.changeProvider(translationProvider);
        Vue.use(TranslationPlugin);
        translateValidationMessages(translateFunction);
        AnmalanService.setTranslateFunction(translateFunction);
    }
}

async function loadPlugins(): Promise<void> {
    Vue.use(ValidationPlugin);
    Vue.use(TestPlugin);
    Vue.use(ErrorPlugin);
}

async function errorHandler(): Promise<void> {
    EventBus.$on(UNHANDLED_ERROR_EVENT, (event: ErrorData) => {
        if (event.info) {
            /* eslint-disable-next-line no-console */
            console.error(event.info);
        }
        /* eslint-disable-next-line no-console */
        console.error(event.error);
        clientLog({ appName: APP_SLUG, message: event.error });
    });
}

async function createApp(): Promise<void> {
    new Vue({
        router,
        store,
        render: (h): VNode =>
            h(FErrorHandlingApp, {
                props: { defaultComponent: App, errorComponent: FkTeknisktfel },
            }),
    }).$mount("#app");
}

async function maxLengthValidation(): Promise<void> {
    Vue.mixin(validationMixin);
}
createLoadingApp()
    .then(errorHandler)
    .then(loadTranslations)
    .then(loadPlugins)
    .then(maxLengthValidation)
    .then(createApp)
    .catch((error) => {
        EventBus.$emit(
            UNHANDLED_ERROR_EVENT,
            new ErrorData(error, null as unknown as Vue, ""),
        );
    });
